import CheckoutBagContainer from './CheckoutBagContainer';
export default CheckoutBagContainer;